import { Route } from '@supsupclub/types';

import { authRoutes } from './auth/routes';
import { commonRoutes } from './common/routes';
import { userRoutes } from './user/routes';

export const HOME_PATH = '/';

export const routes: Route[] = [...userRoutes, ...authRoutes, ...commonRoutes];
